// Spec iter130 (Feb 2026) — État vide unifié pour toutes les listes de
// l'app. Bordure pointillée dans la couleur du module, icône silhouette
// centrée dans la même couleur, texte principal + description, gros CTA
// (bg sombre + accent coloré comme dans iter129).
import { Button } from "@/components/ui/button";

/**
 * <EmptyState /> — bloc visuel unifié pour les listes sans résultat.
 *
 * @param {ReactNode} icon           Icône lucide-react (élément déjà rendu, ex : <Inbox />)
 * @param {string}    title          Ligne principale (ex : « Aucun document »)
 * @param {string}    description    Ligne secondaire italique (peut être null)
 * @param {string}    ctaLabel       Libellé du bouton (peut être null pour cacher le CTA)
 * @param {Function}  onCta          Handler du clic sur le CTA
 * @param {string}    color          Couleur du module (bordure + icône + accent bouton)
 * @param {string}    testId         data-testid racine
 * @param {ReactNode} extra          Slot optionnel sous le CTA (ex : hint « Réinitialiser filtres »)
 */
export default function EmptyState({
  icon,
  title,
  description = null,
  ctaLabel = null,
  onCta = null,
  color = "#2B579A",
  testId = "empty-state",
  extra = null,
}) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-4 py-12 px-6 rounded-lg mx-6 my-4"
      style={{
        border: `1.5px dashed ${color}55`,
        background: `${color}08`,
      }}
      data-testid={testId}
    >
      <div style={{ color }} className="opacity-90">{icon}</div>
      <div className="text-center max-w-md">
        <div className="text-[15px] font-semibold" style={{ color: "#EDEDED" }}>
          {title}
        </div>
        {description && (
          <div className="text-[12.5px] italic mt-1.5" style={{ color: "#9CA3AF" }}>
            {description}
          </div>
        )}
      </div>
      {ctaLabel && onCta && (
        <Button
          type="button"
          size="sm"
          className="h-9 gap-2 px-4 text-[13px] font-semibold border-0"
          style={{
            background: "#1E1E1E",
            color,
            boxShadow: `inset 0 0 0 1.5px ${color}`,
          }}
          onClick={onCta}
          data-testid={`${testId}-cta`}
        >
          {ctaLabel}
        </Button>
      )}
      {extra}
    </div>
  );
}
